module.exports = __webpack_public_path__ + "static/media/virtualbox.0e9e8c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/virtualbox.png
// module id = 108
// module chunks = 0